import React from 'react'

import Base from '../_Base'

const AuG = (props) => (
  <Base width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      d="M24.0249 21.9975C24.0249 23.0983 23.123 24 22.0263 24H2.02349C0.922574 24 0.0249023 23.0983 0.0249023 21.9975V1.99824C0.0249023 0.897513 0.922574 0 2.02349 0H22.0263C23.1272 0 24.0249 0.897513 24.0249 1.99824V21.9975Z"
      fill="white"
    />
    <path
      d="M22.9319 21.0902C22.9319 22.0908 22.1121 22.9106 21.1154 22.9106H2.93447C1.93383 22.9106 1.11792 22.0908 1.11792 21.0902V2.90932C1.11792 1.90868 1.93383 1.09277 2.93447 1.09277H21.1154C22.116 1.09277 22.9319 1.90868 22.9319 2.90932V21.0902Z"
      fill="#0DB14B"
    />
    <path
      d="M13.9531 15.8869C13.395 16.4642 12.7331 16.6759 11.9903 16.6759C11.2475 16.6759 10.6048 16.4026 10.116 15.9138C9.41172 15.2095 9.43096 14.3398 9.43096 13.139C9.43096 11.9382 9.41172 11.0684 10.116 10.368C10.6048 9.87921 11.2052 9.60596 11.9903 9.60596C13.6029 9.60596 14.4226 10.6605 14.6074 11.8343H13.2411C13.0833 11.18 12.683 10.8183 11.9903 10.8183C11.6208 10.8183 11.3168 10.9645 11.1205 11.1916C10.8588 11.4841 10.7895 11.8074 10.7895 13.1428C10.7895 14.4783 10.8588 14.8131 11.1205 15.1056C11.3168 15.3289 11.6208 15.4674 11.9903 15.4674C12.3982 15.4674 12.7292 15.3212 12.9563 15.0787C13.1795 14.8247 13.268 14.5129 13.268 14.1512V13.8895H11.9903V12.758H14.6151V13.774C14.6151 14.7785 14.438 15.3827 13.9492 15.8908L13.9531 15.8869Z"
      fill="white"
    />
    <path
      d="M11.8286 5.2993L4.47388 17.7457H19.5759L12.0249 4.97217L11.8324 5.2993H11.8286ZM12.0249 5.8535C12.3828 6.45774 18.4174 16.672 18.7869 17.2955H5.26284C5.63231 16.672 11.6669 6.45774 12.0249 5.8535Z"
      fill="white"
    />
  </Base>
)

export default AuG
